export function getPerfMarkerConfig(perfMarker) {
  return {
    marker: perfMarker,
    appConfig: {
      get(key) {
        switch (key) {
          case 'LandingPageUrl':
            return window.location.href;
          default:
            return undefined;
        }
      },
    },
  };
}
